import React, { useEffect, useState } from 'react'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido"
import './projects.scss'

const Projects = (props: ReferenciaContenido) => {

    const [regions, setRegions] = useState<string[]>([])
    const [icons, setIcons] = useState<string[]>([])
    const [selectedRegion, setSelectedRegion] = useState<string>('Todo')
    
    const filterRegions = () => {
        let regionsAux: string[] = ['Todo']
        let iconsAux: string[] = ['']
        props.referenciaPlantillaContenido.forEach(function (elem) {
            if ( !regionsAux.includes(elem.youtubeId) ) {
                regionsAux.push(elem.youtubeId)
                if (elem.imagenPrincipal[1]) {
                    iconsAux.push(elem.imagenPrincipal[1].file.url)
                }
            }
        })
        setRegions(regionsAux)
        setIcons(iconsAux)
    }

    useEffect(() => {
        filterRegions()
    }, [])

    const handleFilter = (region) => {
        setSelectedRegion(region)
    }

    return (
        <div className='o-projects'>
            { props.descripcion &&
                <div className="o-projects__desc">
                    <p>{ documentToReactComponents(props.descripcion.json) }</p>
                </div>
            }
            <div className="o-projects__filter">
                {
                    regions.map((region, key) => (
                        <button key={key} onClick={ () => handleFilter(region) } className={`o-projects__filter__btn ${region === selectedRegion ? 'o-projects__filter__btn--active' : ''}`}>
                            { icons.length > 0 &&
                                <img src={icons[key]} alt="" />
                            }
                            <span>{ region }</span>
                        </button>
                    ))
                }
            </div>
            <div className="o-projects__cards">
                {
                    props.referenciaPlantillaContenido.map((card, key) => (
                        (selectedRegion === card.youtubeId || selectedRegion === 'Todo') &&
                        <div key={key} className="o-projects__cards__card">
                            <img src={card.imagenPrincipal[0].file.url} alt="" />
                            <div className="o-projects__cards__card__info">
                                { card.tituloDescripcion &&
                                    <span className="o-projects__cards__card__info__city">
                                        <i className='icon-map-marker-alt'></i>
                                        <span>{ card.tituloDescripcion }</span>
                                    </span>
                                }
                                <span className="o-projects__cards__card__info__title">{ card.tituloBanner }</span>
                                { card.tipoTitulo &&
                                    <span className="o-projects__cards__card__info__price">
                                        <i className='icon-dollar-sign'></i>
                                        <span>{ card.tipoTitulo }</span>
                                    </span>
                                }
                                { card.tituloBoton &&
                                    <span className="o-projects__cards__card__info__area">
                                        <i className='icon-home'></i>
                                        <span>{ card.tituloBoton }</span>
                                    </span>
                                }
                                { card.descripcion &&
                                    <p className="o-projects__cards__card__info__desc">{ documentToReactComponents(card.descripcion.json) }</p>
                                }
                            </div>
                            <a id={ card.idBoton } className='o-projects__cards__card__btn' href={card.redireccionBoton} rel='follow referrer'>
                                Ver más
                            </a>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default Projects